import config from '~/lib/config';

import { BaseService } from '../base';


class Service extends BaseService {}

export default {};
export const ContentService = new Service(`${config.API_VERSION}/contents`);
